// //  
// // Custom Image Field
// // 
export const initCustomImageUpload = () => {
  const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 50MB total size limit
  const MAX_FILE_COUNT = 10;

  const wrapper = document.querySelector(".custom-file__image:not([data-upload-initialized])");
  const dropzone = document.querySelector(".custom-upload-dropzone");
  const fileInput = document.querySelector('input[type="file"]');
  const labelText = document.querySelector(".custom-file__image-label label.custom-file-input");

  if (!wrapper || !dropzone || !fileInput) return;

  wrapper.dataset.uploadInitialized = "1";

  const previewContainer = document.createElement("div");
  previewContainer.className = "custom-upload-preview";
  wrapper.appendChild(previewContainer);

  let selectedFiles = [];

  wrapper.addEventListener("click", (e) => {
    if (!e.target.classList.contains("remove-file")) {
      fileInput.click();
    }
  });

  wrapper.addEventListener("dragover", (e) => {
    e.preventDefault();
    dropzone.classList.add("drag-over");
  });

  wrapper.addEventListener("dragleave", () => {
    dropzone.classList.remove("drag-over");
  });

  wrapper.addEventListener("drop", (e) => {
    e.preventDefault();
    dropzone.classList.remove("drag-over");
    if (e.dataTransfer?.files?.length) {
      addFiles([...e.dataTransfer.files]);
    }
  });

  fileInput.addEventListener("change", () => {
    if (fileInput.files?.length) {
      addFiles([...fileInput.files]);
    }
  });

  function addFiles(files) {
    if (!files || !files.length) return;

    const validFiles = [];
    const currentCount = selectedFiles.length;
    const currentTotalSize = selectedFiles.reduce((total, file) => total + file.size, 0);

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // Calculate new total size if this file is added
      const newTotalSize = currentTotalSize + validFiles.reduce((sum, f) => sum + f.size, 0) + file.size;

      // Skip if adding this file would exceed total size limit
      if (newTotalSize > MAX_TOTAL_SIZE) {
        const maxFileSize = document.querySelector(".custom-file__image-max-file-size");
        maxFileSize.classList.remove("d-none");
        continue;
      }

      // Prevent duplicates
      const isDuplicate = selectedFiles.some(
        f => f.name === file.name && f.size === file.size
      );
      if (isDuplicate) continue;

      // Prevent total file count overflow
      if (currentCount + validFiles.length >= MAX_FILE_COUNT) {
        const maxFileCount = document.querySelector(".custom-file__image-max-file-count");
        maxFileCount.classList.remove("d-none");
        maxFileCount.textContent = `Maximum of ${MAX_FILE_COUNT} files allowed.`;
        break;
      }

      validFiles.push(file);
    }

    selectedFiles = [...selectedFiles, ...validFiles];
    renderPreviews();
    fileInput.classList.remove('error');
    const formGroup = fileInput.closest('.form-group');
    if (formGroup) formGroup.classList.remove('form-group-error');
  }

  function renderPreviews() {
    previewContainer.innerHTML = "";

    selectedFiles.forEach((file, index) => {
      const fileDiv = document.createElement("div");
      fileDiv.className = "preview-item";
      const isImage = file.type.startsWith("image/");
      const fileContent = isImage
        ? `<img src="${URL.createObjectURL(file)}" alt="${file.name}" />`
        : `<span class="file-icon">📄</span>`;
      fileDiv.innerHTML = `
        ${fileContent}
        <span class="file-name">${file.name}</span>
        <button type="button" class="remove-file" data-index="${index}"></button>
      `;
      previewContainer.appendChild(fileDiv);
    });

    updateFileName(selectedFiles.map(f => f.name).join(", "));

    previewContainer.querySelectorAll(".remove-file").forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const i = parseInt(btn.dataset.index);
        if (!isNaN(i)) {
          selectedFiles.splice(i, 1);
          renderPreviews();
        }
      });
    });
  }

  function updateFileName(nameList) {
    if (labelText) {
      labelText.textContent = nameList || "Choose files";
    }
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCustomImageUpload, { once: true });
} else {
  initCustomImageUpload();
}
